// Copyright (c) 2024 The Bitcoin developers
// Distributed under the MIT software license, see the accompanying
// file COPYING or http://www.opensource.org/licenses/mit-license.php.

import * as React from 'react';
import styled from 'styled-components';
import {
    CashtabSettings,
} from 'config/cashtabSettings';
import appConfig from 'config/tokenConfig';
import { CashtabLoader } from 'components/Common/Spinner';
import PropTypes from 'prop-types';
import {TOKEN_ID} from "../../constants";

export const BalanceXec = styled.div`
    width: 100%;
    font-size: 28px;
    margin-bottom: 0px;
    font-weight: bold;
    line-height: 1.4em;
    @media (max-width: 768px) {
        font-size: 24px;
    }
    color: ${props =>
        props.balanceVisible ? 'transparent' : props.theme.contrast};
    text-shadow: ${props => (props.balanceVisible ? '0 0 15px #fff' : 'none')};
`;
export const BalanceFiat = styled.div`
    width: 100%;
    font-size: 16px;
    @media (max-width: 768px) {
        font-size: 16px;
    }
    color: ${props =>
        props.balanceVisible ? 'transparent' : props.theme.contrast};
    text-shadow: ${props => (props.balanceVisible ? '0 0 15px #fff' : 'none')};
`;


const TokenBalanceHeader = ({
    walletState = null,
    settings = new CashtabSettings(),
}) => {
    // If navigator.language is undefined, default to en-US
    const {balanceSats, tokens} = walletState
    const renderBalanceHeader = Number.isInteger(balanceSats);
    const tokenBalance = tokens.get(TOKEN_ID);

    // Render a spinner if the balance is not loaded
    return !renderBalanceHeader ? (
        <CashtabLoader />
    ) : (
        <>
            <BalanceXec
                title="Balance in XEC"
                balanceVisible={settings.balanceVisible === false}
            >
                {tokenBalance?tokenBalance:0} {appConfig.ticker}{' '}
            </BalanceXec>

        </>
    );
};

TokenBalanceHeader.propTypes = {
    walletState: PropTypes.object,
    settings: PropTypes.oneOfType([
        PropTypes.shape({
            fiatCurrency: PropTypes.string,
            sendModal: PropTypes.bool,
            autoCameraOn: PropTypes.bool,
            hideMessagesFromUnknownSender: PropTypes.bool,
            toggleShowHideBalance: PropTypes.bool,
        }),
        PropTypes.bool,
    ]),
    fiatPrice: PropTypes.number,
    userLocale: PropTypes.string,
};

export default TokenBalanceHeader;
